import { createApi } from '../createApi';
import * as dummy from '../dummy/users';
import * as real from '../api/users';

const api = createApi(dummy, real);

/** 유저 프로필 서비스 — API_DOCS: 2. 유저 (Users) */
export const userService = {
  getProfile: api.getProfile,
  updateProfile: api.updateProfile,
  changePassword: api.changePassword,
  deleteAccount: api.deleteAccount,
  getMyReviews: api.getMyReviews,
  getMyWaitlist: api.getMyWaitlist,
};
